module.exports = __webpack_public_path__ + "assets/icons/window-open.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/svg/window-open.svg
// module id = Ihtr
// module chunks = 1